import type {PerkUsagePreviewComponentProps} from '@cohort/merchants/apps';

export const InstagramCloseFriendsListPerkIntegrationsUsagePreviewComponent: React.FC<
  PerkUsagePreviewComponentProps
> = ({perk}) => {
  return (
    <div>InstagramCloseFriendsListPerkIntegrationsUsagePreviewComponent - TODO - {perk.id}</div>
  );
};
